export const formatGridWidth = (preWidth, minWidth = 0) => {
    if (typeof preWidth === "number") {
        return `${Math.max(preWidth, minWidth)}px`;
    }
    return preWidth;
};
export const transformGridWidth2Number = (preWidth, minWidth = 0) => {
    if (typeof preWidth === "number") {
        return Math.max(preWidth, minWidth);
    }
    return 1200;
};
export function getCellWidthByGrid({ contentWidth, gridCol, gridGap, }) {
    return +((contentWidth - gridGap * (gridCol - 1)) / gridCol).toFixed(1);
}
